export function concatWithDot(...args: string[]): string {
  return args.join('.');
}
